import { createContext } from "react";

const gallaryContext = createContext();

export default gallaryContext;